import { formatCoins } from '../../lib/idle/format';
import { GEM_UPGRADES } from '../../lib/idle/gameConfig';
import { buyUpgrade, useIdle } from '../../lib/idle/idleStore';
import { usePremium } from '../../lib/session';
import { useUI } from '../../lib/ui';
import GemIcon from '../Idle/GemIcon';
import Styles from './GemsPanel.module.css';

const GemsPanel = () => {
  const state = useIdle();
  const premium = usePremium();
  const openPricing = useUI((s) => s.openPricing);

  return (
    <div className={Styles.panel}>
      <div className={Styles.top}>
        <span className={Styles.balance}>
          <GemIcon size={24} /> <strong>{formatCoins(state.gems)}</strong>
        </span>
      </div>

      <ul className={Styles.list}>
        {GEM_UPGRADES.map((u) => {
          const owned = Boolean(state.bought[u.id]);
          return (
            <li key={u.id} className={`${Styles.row} ${owned ? Styles.rowOwned : ''}`}>
              <span className={Styles.icon}>
                <GemIcon size={26} />
              </span>
              <span className={Styles.text}>
                <h3 className={Styles.name}>{u.name}</h3>
                <p className={Styles.desc}>{u.desc}</p>
              </span>
              {owned ? (
                <span className={Styles.owned}>Owned</span>
              ) : (
                <button
                  type="button"
                  className={Styles.buy}
                  disabled={state.gems < u.cost}
                  onClick={() => buyUpgrade(u.id)}
                  aria-label={`Buy ${u.name} for ${u.cost} gems`}
                >
                  <GemIcon size={14} /> {u.cost}
                </button>
              )}
            </li>
          );
        })}
      </ul>

      <p className={Styles.foot}>Paper themes switch on when you buy them. Swap back in Settings.</p>
    </div>
  );
};

export default GemsPanel;